import React, { useState, useMemo } from 'react';
import DefaultLayout from 'admin/components/DefaultLayout';
import { useAuth } from 'hooks/useAuth';
import { useIntl } from 'react-intl';
import { Pagination } from '../../../types/Pagination';
import {
    Button,
    Table,
    Dropdown,
    Modal,
} from 'ui';
import dayjs from 'dayjs';
import useQueryApiClient from '../../../utils/useQueryApiClient';

const NotificationListPage = () => {

    const intl = useIntl();
    const { user } = useAuth();
    const [paginationStatus, setPaginationStatus] = useState<Pagination>({});

    const stableFilter = useMemo(() => {
        return { farmId: user?.farmId };
    }, [user?.farmId]);

    const columns = [
        {
            title: intl.formatMessage({ id: 'general.date' }),
            dataIndex: 'created_at',
            render: (value: string) => value && dayjs(value).format('DD.MM.YYYY'),
        },
        {
            title: intl.formatMessage({ id: 'general.notification' }),
            dataIndex: 'content',
        },
        {
            title: intl.formatMessage({ id: 'general.viewed' }),
            dataIndex: 'viewed',
            render: (value: boolean) =>
                value
                    ? intl.formatMessage({ id: 'general.yes' })
                    : intl.formatMessage({ id: 'general.no' }),
        },
        {
            title: intl.formatMessage({ id: 'general.type' }),
            dataIndex: 'type',
        },
        {
            title: intl.formatMessage({ id: 'general.actions' }),
            dataIndex: 'actions',
            render: (text: string, record: any) => (
                ''
            ),
        }
    ];

    const handleNotificationAction = (id: number, action: string) => {
        // Handle notification actions based on the action type
        switch (action) {
            case 'view':
                // Handle view action
                break;
            case 'markAsRead':
                // Handle mark as read action
                break;
            case 'delete':
                // Handle delete action
                break;
            default:
                break;
        }
    };

    return (
        <DefaultLayout.PageLayout
            breadcrumbs={[
                {
                    title: intl.formatMessage({ id: 'navigation.beginning' }),
                },
                {
                    title: intl.formatMessage({ id: 'navigation.notifications' }),
                },
            ]}
        >
            <DefaultLayout.PageContent>
                <Table
                    url={`api/v2/notifications`}
                    columns={columns}
                    filter={stableFilter}
                    paginnationStatus={(el: object) => {
                        setPaginationStatus(el);
                    }}
                    rowKey="id"
                />
            </DefaultLayout.PageContent>
        </DefaultLayout.PageLayout>
    );
};

export default NotificationListPage;
